export var CorrelationMatrixSubTab;
(function (CorrelationMatrixSubTab) {
    CorrelationMatrixSubTab["HOLDINGS"] = "holdings";
    CorrelationMatrixSubTab["PEER"] = "peer";
})(CorrelationMatrixSubTab || (CorrelationMatrixSubTab = {}));
